"use client";

import type { ReactNode } from "react";
import { ChevronRightIcon } from "../lifestyleIcons";

interface FilterModalButtonProps {
  label: string;
  /** Replaces the label once a selection is made. */
  selectedLabel?: string | null;
  /**
   * Mobile collapses this to a 40px icon tile, as drawn, and the label comes
   * back from `lg:` up. Requires `icon`.
   */
  compact?: boolean;
  icon?: ReactNode;
  className?: string;
  onClick: () => void;
}

/**
 * Filter bar trigger for the Collections / Categories modal. Deliberately
 * mirrors the FilterDropdown trigger so the bar reads as one set of controls
 * even though Sort by still opens an inline menu.
 */
export default function FilterModalButton({
  label,
  selectedLabel,
  compact = false,
  icon,
  className = "",
  onClick,
}: FilterModalButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-haspopup="dialog"
      // The label is hidden while compact, so it has to be named either way.
      aria-label={selectedLabel || label}
      className={`flex items-center min-h-10 lg:min-h-11 gap-2 font-roboto text-base font-medium leading-5.5 text-secondary bg-white rounded border border-transparent transition-colors hover:border-gray-8 ${
        compact ? "justify-center lg:justify-between w-10 lg:w-auto px-0 lg:px-3" : "justify-between px-3"
      } ${className}`}>
      {compact && icon && <span className="lg:hidden text-primary">{icon}</span>}
      <span className={`truncate ${compact ? "hidden lg:inline" : ""}`}>{selectedLabel || label}</span>
      <ChevronRightIcon className={`shrink-0 w-5 h-5 text-gray-5 ${compact ? "hidden lg:block" : ""}`} />
    </button>
  );
}
